








"use strict";

const httpUtil = require("common-util/browser/http-util.js");
const XuxTableSupport = require("common-util/browser/xux-table-support.js");
const {WebStorageManager} = require("common-util/browser/webstorage-util.js");
const storage = new WebStorageManager();
const app = require("./app-common.js");
const order = require("./order.js");
const Util = require("./util");
const util = new Util();
const moment = require("moment");
const HISTORY_PAGE_SIZE = 300;

app.init(true);

app.ready(() => {
    util.afterLoginApply(app, order, "history");
    util.logOutHeader(app);
    util.initSupportMenu(app);
    util.initLogoutMenu(app);
    $("#body").xuxPage({
        width: "full",
        loginout: true,
        itemStates: ["", "", "selected", ""]
    });
    $("#tabs").xuxTabbedSet({
        loadTiming: "everyTime",
        activate(event, target) {
            target.newPanel.find(".list-table").xuxDecoratedTable("reload");
        }
    });

    $("header").xuxHeader("utilityLinks")
        .xuxUtilityLinks("option", "user", app.session.userName);

    let statusDetailModalWindow = util.patchModalWindow("#status_detail");
    statusDetailModalWindow.xuxModalWindow();

    let getResultDetail = function (item, prefix) {
        let key = "";
        if (item.get("successWithWarnings")) {
            key = item.get("successWithWarningsResultDetailOnClient");
        } else if (item.get("partiallyFailed")) {
            key = item.get("partiallyFailedResultDetailOnClient");
        } else if (item.get("failed") || prefix === "history") {
            let SERVER_RESULT = prefix + "ResultDetail";
            let CLIENT_RESULT = prefix === "activity" ? "failedResultDetailOnClient" : "historyResultDetailOnClient";
            if (item.get(CLIENT_RESULT)) {
                key = item.get(CLIENT_RESULT);
            } else if (item.get(SERVER_RESULT)) {
                let serverResult = item.get(SERVER_RESULT);
                if (typeof serverResult === "string") {
                    key = serverResult;
                } else {
                    let {title, message} = util.makeErrorMessage(serverResult);
                    key = title + "\n" + message;
                }
            }
        } else { 
            key = "";
        }

        return key || "";
    };

    let showHistoryStatusDetail = function (options) {
        let label, detail, isTextarea, labelDiv, textareaDiv;
        $("#status_detail").find("h2").empty().append(util.text(options.title));
        $("#status_detail_content").empty().append("<div></div>");
        $.each(options.showItems, (index, item) => {
            detail = item.value;
            isTextarea = item.textarea;
            label = item.label === "name" ? window.localizedTextMessages.settings.label[item.label]
                : window.localizedTextMessages.history.label[item.label];
            if (isTextarea) {
                labelDiv = "<div><label><b>" + util.text(label) + "</b></label></div>";
                textareaDiv = "<div><textarea style='width: 570px;height: 260px;' readonly='readonly'>"
                + detail.replace(/<br>/g, "\n") + "</textarea></div>";
                $("#status_detail_content").children("div").append(labelDiv).append(textareaDiv);
            } else {
                labelDiv = "<div><label><b>" + util.text(label) + "</b></label>" + util.text(detail) + "</div>";
                $("#status_detail_content").children("div").append(labelDiv).addClass("breakall");
            }
        });
        $("#status_detail_content").children("div").xuxApplyBox({
            labelLayout: "leading"
        });
        $("#status_detail").find("button").unbind("click").click(() => {
            statusDetailModalWindow.xuxModalWindow("close");
        });
        $("#common_detail_content").find("label").css("min-width", "132px");
        statusDetailModalWindow.xuxModalWindow("open");
    };

    let setTextLink = function (item, td, title, showItems, statusType) {
        let link = $("<a href='javascript:void(0)'>" + util.text(item.get(statusType)) + "</a>").xuxHyperlink();
        link.click(() => {
            window.document.activeElement.blur();
            showHistoryStatusDetail({title, showItems});
        });

        td.append(link);
    };

    let activtiyTypeFormatter = function (value, item) {
        let key;
        if (item.get("successful")) {
            key = window.localizedTextMessages.api.successful;
        } else if (item.get("successWithWarnings")) {
            key = window.localizedTextMessages.api.successWithWarnings;
        } else if (item.get("partiallyFailed")) {
            key = window.localizedTextMessages.api.partiallyFailed;
        } else if (item.get("canceledByUser")) {
            key = window.localizedTextMessages.api.canceledByUser;
        } else if (item.get("canceledBySystem")) {
            key = window.localizedTextMessages.api.canceledBySystem;
        } else if (item.get("failed")) {
            key = window.localizedTextMessages.api.failed;
        } else if (item.get("expired")) {
            key = window.localizedTextMessages.api.expired;
        }
        return key;
    };

    $.backupNextId = [];
    $.installNextId = [];
    $.operationNextId = [];
    let backupHistoryTable = $("#backup-history-table");

    let tableSupport = new XuxTableSupport({
        elem: backupHistoryTable,
        l10n: app.l10n,
        columns: {
            createdAt: {
                _localizationLabel: "history.label.backupDate",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "desc",
                _sortByBeforeFormat: true,
                _formatter(value) {
                    return $.xux.formatDateTime(util.getDate(value), {seconds: true});
                }
            },
            settingName: {
                _localizationLabel: "settings.label.name",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            displayName: {
                _localizationLabel: "history.label.backupFrom",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            userName: {
                _localizationLabel: "history.label.operator",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value) {
                    return value || window.localizedTextMessages.api.system;
                }
            },
            successful: {
                _hidden: true
            },
            failed: {
                _hidden: true
            },
            expired: {
                _hidden: true
            },
            canceledByUser: {
                _hidden: true
            },
            canceledBySystem: {
                _hidden: true
            },
            activityResultDetail: {
                _hidden: true
            },
            failedResultDetailOnClient: {
                _hidden: true
            },
            partiallyFailedResultDetailOnClient: {
                _hidden: true
            },
            successWithWarningsResultDetailOnClient: {
                _hidden: true
            },
            successWithWarnings: {
                _hidden: true
            },
            partiallyFailed: {
                _hidden: true
            },
            activityType: {
                _localizationLabel: "history.label.status",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter: activtiyTypeFormatter,
                render(td, item) {
                    let showItems = [{value: item.get("createdAt"), label: "backupDate"},
                                     {value: item.get("settingName"), label: "name"},
                                     {value: item.get("displayName"), label: "backupFrom"},
                                     {value: item.get("userName"), label: "operator"},
                                     {value: item.get("activityType"), label: "status"},
                                     {value: getResultDetail(item, "activity"), label: "detail", textarea: true}
                    ];

                    if (item.get("failed") || item.get("partiallyFailed") || item.get("successWithWarnings")) {
                        setTextLink(item, td, window.localizedTextMessages.history.title.backupDetail, showItems, "activityType");
                    } else {
                        td.append(util.text(item.get("activityType")));
                    }
                }
            },
            activityStatusDetail: {
                _hidden: true
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "unindexed",
            itemsPerPage: HISTORY_PAGE_SIZE,
            maxLoadedCacheSize: 1,
            xuxPagesPerLoad: 1,
            fetch(_fetchOption, xuxOptions) {
                let pageNum = xuxOptions.start / HISTORY_PAGE_SIZE;
                let url = tableSupport.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/history/backup") + "?timestamp=" + Date.now());
                let fromDate = "";
                if ($("#backup-history-date").val()) {
                    fromDate = moment($("#backup-history-date").val(), "YYYY-MM-DD").format();
                }
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        fromId: $.backupNextId[pageNum - 1],
                        fromDate,
                        max: HISTORY_PAGE_SIZE,
                        orderId: storage.getItem("orderId")
                    },
                    success(data) {
                        $.backupNextId[pageNum] = JSON.stringify(data.nextId);
                    }
                });
            }},
        xuxOptions: {
            pageNumbers: false,
            xuxPageCacheRate: 1,
            columnResizable: true,
            sortOptions: {
                column: 0,
                order: "desc"
            },
            pageNavigation: "both",
            autoLoad: false,
            selectionUnit: "none"
        }});

    tableSupport.init();

    let installHistoryTable = $("#install-history-table");
    let installHistoryTableSupport = new XuxTableSupport({
        elem: installHistoryTable,
        l10n: app.l10n,
        columns: {
            createdAt: {
                _localizationLabel: "history.label.installDate",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "desc",
                _sortByBeforeFormat: true,
                _formatter(value) {
                    return $.xux.formatDateTime(util.getDate(value), {seconds: true});
                }
            },
            settingName: {
                _localizationLabel: "settings.label.name",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            displayName: {
                _localizationLabel: "history.label.installTo",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            userName: {
                _localizationLabel: "history.label.operator",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value) {
                    return value || window.localizedTextMessages.api.system;
                }
            },
            successful: {
                _hidden: true
            },
            failed: {
                _hidden: true
            },
            expired: {
                _hidden: true
            },
            canceledByUser: {
                _hidden: true
            },
            canceledBySystem: {
                _hidden: true
            },
            activityResultDetail: {
                _hidden: true
            },
            failedResultDetailOnClient: {
                _hidden: true
            },
            partiallyFailedResultDetailOnClient: {
                _hidden: true
            },
            successWithWarningsResultDetailOnClient: {
                _hidden: true
            },
            successWithWarnings: {
                _hidden: true
            },
            partiallyFailed: {
                _hidden: true
            },
            activityType: {
                _localizationLabel: "history.label.status",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter: activtiyTypeFormatter,
                render(td, item) {
                    let showItems = [{value: item.get("createdAt"), label: "installDate"},
                                     {value: item.get("settingName"), label: "name"},
                                     {value: item.get("displayName"), label: "installTo"},
                                     {value: item.get("userName"), label: "operator"},
                                     {value: item.get("activityType"), label: "status"},
                                     {value: getResultDetail(item, "activity"), label: "detail", textarea: true}
                    ];

                    if (item.get("failed") || item.get("partiallyFailed") || item.get("successWithWarnings")) {
                        setTextLink(item, td, window.localizedTextMessages.history.title.installDetail, showItems, "activityType");
                    } else {
                        td.append(util.text(item.get("activityType")));
                    }
                }
            },
            activityStatusDetail: {
                _hidden: true
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "unindexed",
            itemsPerPage: HISTORY_PAGE_SIZE,
            maxLoadedCacheSize: 1,
            xuxPagesPerLoad: 1,
            fetch(_fetchOption, xuxOptions) {
                let pageNum = xuxOptions.start / HISTORY_PAGE_SIZE;
                let url = installHistoryTableSupport.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/history/restore") + "?timestamp=" + Date.now());
                let fromDate = "";
                if ($("#install-history-date").val()) {
                    fromDate = $("#install-history-date").val();
                }
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        fromId: $.installNextId[pageNum - 1],
                        fromDate,
                        max: HISTORY_PAGE_SIZE,
                        orderId: storage.getItem("orderId")
                    },
                    success(data) {
                        $.installNextId[pageNum] = JSON.stringify(data.nextId);
                    }
                });
            }},
        xuxOptions: {
            pageNumbers: false,
            xuxPageCacheRate: 1,
            columnResizable: true,
            autoLoad: false,
            sortOptions: {
                column: 0,
                order: "desc"
            },
            pageNavigation: "both",
            selectionUnit: "none"
        }});

    installHistoryTableSupport.init();

    let operationHistoryTable = $("#operation-history-table");
    let operationHistoryTableSupport = new XuxTableSupport({
        elem: operationHistoryTable,
        l10n: app.l10n,
        columns: {
            createdAt: {
                _localizationLabel: "history.label.operateDate",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "desc",
                _sortByBeforeFormat: true,
                _formatter(value) {
                    return $.xux.formatDateTime(util.getDate(value), {seconds: true});
                }
            },
            historyType: {
                _localizationLabel: "history.label.operateType",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value) {
                    let key;
                    if (value === "deviceRegistration") {
                        key = window.localizedTextMessages.api.deviceRegistration;
                    } else if (value === "deviceDeletion") {
                        key = window.localizedTextMessages.api.deviceDeletion;
                    } else if (value === "toolUpload") {
                        key = window.localizedTextMessages.api.toolUpload;
                    } else if (value === "toolDownload") {
                        key = window.localizedTextMessages.api.toolDownload;
                    } else if (value === "dataDeletion") {
                        key = window.localizedTextMessages.api.dataDeletion;
                    } else if (value === "batchDataDeletion") {
                        key = window.localizedTextMessages.api.batchDataDeletion;
                    } else if (value === "orderCreate") {
                        key = window.localizedTextMessages.api.createOrder;
                    } else if (value === "orderFinish") {
                        key = window.localizedTextMessages.api.finishOrder;
                    }

                    return key;
                }
            },
            settingName: {
                _hidden: true
            },
            displayName: {
                _hidden: true
            },
            historyResultDetail: {
                _hidden: true
            },
            historyResultDetailOnClient: {
                _hidden: true
            },
            operateTarget: {
                _localizationLabel: "history.label.operateTarget",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value, item) {
                    let key;
                    let historyType = item.getOriginal("historyType");
                    let historyResult = item.getOriginal("historyResult");
                    if (historyType === "deviceRegistration" || historyType === "deviceDeletion") {
                        key = item.get("displayName");
                    } else if (historyType === "toolUpload" || historyType === "toolDownload"
                        || historyType === "dataDeletion") {
                        key = item.get("settingName");
                    } else if (historyType === "batchDataDeletion") {
                        key = historyResult === "successful" ? item.get("settingName") : window.localizedTextMessages.api.operateTargetSettings;
                    } else if (historyType === "orderCreate" || historyType === "orderFinish") {
                        key = item.get("displayName");
                    }
                    return key;
                }
            },
            userName: {
                _localizationLabel: "history.label.operator",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value) {
                    return value || window.localizedTextMessages.api.system;
                }
            },
            client: {
                _localizationLabel: "history.label.operateClient",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value) {
                    let key;
                    if (value === "device") {
                        key = window.localizedTextMessages.api.device;
                    } else if (value === "tool") {
                        key = window.localizedTextMessages.api.tool;
                    } else if (value === "webui") {
                        key = window.localizedTextMessages.api.webui;
                    }

                    return key;
                }
            },
            historyResult: {
                _localizationLabel: "history.label.status",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value) {
                    let key;
                    if (value === "successful") {
                        key = window.localizedTextMessages.api.successful;
                    } else if (value === "failed") {
                        key = window.localizedTextMessages.api.failed;
                    } else if (value === "canceledByUser") {
                        key = window.localizedTextMessages.api.canceledByUser;
                    } else if (value === "canceledBySystem") {
                        key = window.localizedTextMessages.api.canceledBySystem;
                    } else if (value === "expired") {
                        key = window.localizedTextMessages.api.expired;
                    }

                    return key;
                },
                render(td, item) {
                    let showItems = [{value: item.get("createdAt"), label: "operateDate"},
                                     {value: item.get("historyType"), label: "operateType"},
                                     {value: item.get("operateTarget"), label: "operateTarget"},
                                     {value: item.get("userName"), label: "operator"},
                                     {value: item.get("client"), label: "operateClient"},
                                     {value: item.get("historyResult"), label: "status"},
                                     {value: getResultDetail(item, "history"), label: "detail", textarea: true}
                    ];

                    if (item.get("historyResult") === window.localizedTextMessages.api.failed) {
                        setTextLink(item, td, window.localizedTextMessages.history.title.operateDetail, showItems, "historyResult");
                    } else {
                        td.append(util.text(item.get("historyResult")));
                    }
                }
            },
            historyStatusDetail: {
                _hidden: true
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "unindexed",
            itemsPerPage: HISTORY_PAGE_SIZE,
            maxLoadedCacheSize: 1,
            xuxPagesPerLoad: 1,
            fetch(_fetchOption, xuxOptions) {
                let pageNum = xuxOptions.start / HISTORY_PAGE_SIZE;
                let url = operationHistoryTableSupport.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/history/operation") + "?timestamp=" + Date.now());
                let fromDate = "";
                if ($("#operation-history-date").val()) {
                    fromDate = $("#operation-history-date").val();
                }
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        fromId: $.operationNextId[pageNum - 1],
                        fromDate,
                        max: HISTORY_PAGE_SIZE,
                        orderId: storage.getItem("orderId")
                    },
                    success(data) {
                        $.operationNextId[pageNum] = JSON.stringify(data.nextId);
                    }
                });
            }},
        xuxOptions: {
            pageNumbers: false,
            xuxPageCacheRate: 1,
            columnResizable: true,
            sortOptions: {
                column: 0,
                order: "desc"
            },
            autoLoad: false,
            pageNavigation: "both",
            selectionUnit: "none"
        }});

    operationHistoryTableSupport.init();
    if (!app.session.tenant.isFXTenant || storage.getItem("orderId")) {
        $("#backup-history-table").xuxDecoratedTable("load");
    }
    util.setTimeDropdown($(".history-hour"), $(".history-time"));
    $(".history-date").xuxDateField();
    $("#backup-history-date").change(() => {
        $("#backup-history-table").xuxDecoratedTable("reload");
    });
    $("#install-history-date").change(() => {
        $("#install-history-table").xuxDecoratedTable("reload");
    });
    $("#operation-history-date").change(() => {
        $("#operation-history-table").xuxDecoratedTable("reload");
    });
    $(".history-hour").xuxDropdown();
    $(".history-time").xuxDropdown();
    if (app.session.tenant.isFXTenant) {
        $(".orderIdDiv").xuxApplyBoxAndLayout({
            labelLayout: "leading",
            contentEllipsis: true
        });
    } else {
        $(".orderIdDiv").xuxApplyBoxAndLayout().hide();
    }

    $("#orderid-update").click(() => {
        order.openOrderList(app);
    });

    $("#install-history-article").xuxBoundingBox();
    $("#operation-history-article").xuxBoundingBox();
});
